import "./Card.css";
import comingsoon from "./images.jpeg";

function Card() {
    return (
      <div className="Activitiescardcss">
        <img className="ActImage" src={comingsoon} alt={""}></img>
      </div>
    );
  }
  
export default Card;